import React from "react";

export const Boson = ({ size }: { size: number }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="-2 -50 330 330"
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      shapeRendering="geometricPrecision"
      clipRule="evenodd"
    >
      <path
        fill="#02F3A2"
        d="M47.3192 45.2065C59.0024 44.9177 70.5637 47.6657 80.8975 53.1875C91.2313 58.7093 99.992 66.8205 106.343 76.7456C108.421 74.275 110.292 71.8571 112.37 69.5968C115.633 66.3604 119.542 63.8671 123.835 62.2841C128.129 60.7011 132.707 60.065 137.264 60.4184C141.82 60.7719 146.248 62.1067 150.253 64.3334C154.258 66.56 157.746 69.627 160.483 73.3289C166.919 83.5949 172.15 94.5852 176.07 106.077C178.969 113.915 182.443 121.523 186.462 128.838C187.145 130.348 188.243 131.627 189.625 132.524C191.006 133.421 192.614 133.898 194.255 133.898C195.897 133.898 197.504 133.421 198.885 132.524C200.267 131.627 201.365 130.348 202.049 128.838C205.418 122.673 207.72 115.971 208.855 109.021C210.323 99.1132 213.451 89.5315 218.104 80.688C224.664 68.9657 234.422 59.4032 246.213 53.1439C256.297 47.612 267.633 44.8398 279.102 45.1014V66.9159C251.252 68.2301 233.951 90.2023 234.574 109.809C235.198 129.416 252.395 149.654 279.102 150.6V171.626C262.943 175.095 234.158 162.374 221.221 141.506C218.569 146.059 214.83 149.865 210.345 152.575C205.86 155.285 200.774 156.811 195.554 157.013C176.486 158.432 166.458 148.76 160.327 134.883C154.819 122.425 150.507 109.546 145.571 96.9306C144.488 94.1173 143.093 91.4371 141.414 88.9408C136.894 82.5278 129.152 83.6843 123.905 91.3063C119.06 99.1445 116.089 108.018 115.227 117.221C112.976 131.02 106.14 143.629 95.8474 152.965C86.6095 162.025 75.0281 168.257 62.439 170.943C57.659 171.941 52.6188 172.152 47.2152 172.782V150.284C53.1997 150.474 59.158 149.404 64.7122 147.142C70.2664 144.879 75.2959 141.475 79.4813 137.143C83.9858 133.023 87.4496 127.871 89.5829 122.119C91.7162 116.366 92.4569 110.181 91.7432 104.08C89.5609 87.4164 74.233 68.1249 47.1112 66.7056L47.3192 45.2065Z"
      />
      <path
        fill="#02F3A2"
        d="M304.113 22.3928V195.332H22.5792V22.3928H304.113ZM326.693 0H0V217.778H326.693V0Z"
      />
      <path
        fill="#02F3A2"
        d="M304.112 22.4044V195.433H22.5792V22.4044H304.112ZM326.692 0H0V217.89H326.692V0Z"
      />
    </svg>
  );
};
